import { REACT_APP_API_PREFIX } from "config/env";
import { DELETE, GET, POST, PUT } from "constants/methods";

const service = "harmony";
const changelogs = `${REACT_APP_API_PREFIX}/${service}/changelogs`;

export function getHarmonyChangelogs(filters) {
  const url = `${changelogs}${
    filters ? `?filters=${JSON.stringify(filters)}` : ""
  }`;
  return {
    method: GET,
    url,
  };
}

export function getHarmonyChangelogById(id) {
  const url = `${changelogs}/${id}/full`;
  return {
    method: GET,
    url,
  };
}

export function updateHarmonyChangelog(id, body) {
  const url = `${changelogs}/${id}`;
  return {
    method: PUT,
    url,
    body,
  };
}

export function deleteHarmonyChangelog(id) {
  const url = `${changelogs}/${id}`;
  return {
    method: DELETE,
    url,
  };
}

export function createHarmonyChangelog(body) {
  const url = `${changelogs}`;
  return {
    method: POST,
    url,
    body,
  };
}
